import { ITemplatesSearchCriteria } from './types';

export const argumentifyTemplatesSearchCriteria = ({
  filterText,
  skipCount,
  maxResultCount,
}: ITemplatesSearchCriteria) => [filterText, skipCount, maxResultCount] as const;
